import axios from 'axios';
import { useQuery } from 'react-query';

import errorHandler from '../../helpers/errorHandler';

export default function useSocialProfile(
  socialProfileId,
  serializerView = 'normal',
  queryKey = 'social_profile',
  callback = () => {}
) {
  return useQuery(
    [queryKey, socialProfileId, serializerView],
    async ({ signal }) => {
      const res = await axios
        .get(
          window.Routes.api_clients_social_profile_path({
            id: socialProfileId,
            serializer_view: serializerView,
          }),
          {
            signal,
          }
        )
        .catch(errorHandler.handleError);

      return res ? res.data : {};
    },
    {
      success: (data) => {
        if (callback) callback(data);
      },
    }
  );
}
